<a
  class="link"
  (click)="openLink()">
  <ng-content></ng-content>
</a>
